import {
  Box,
  Header,
  Main,
  Grommet,
  Text,
  Footer,
  Grid,
  Layer,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  TextInput,
  Button,
  FileInput,
  Form,
  FormField,
  Image,
  CheckBox,
  RadioButtonGroup,
  Meter,
  Stack,
  Spinner,
  Page,
  PageContent,
} from "grommet";
import { grommetTheme } from "grommet/themes";
import { Mail, Login, User, Validate, FormNextLink, Phone, Underline } from "grommet-icons";
import logo from "./assets/logo.svg";
import loading from "./assets/loading.gif";
import React, { useEffect, useState } from "react";
import VimeoUpload from "./components/vimeo-upload.js";

import Vimeo from 'vimeo';
import dayjs from 'dayjs';
//import customParseFormat from 'dayjs/plugin/customParseFormat';
import {Parser as HtmlToReactParser} from 'html-to-react';
//import testmp4 from './sample.mp4';
//import testmov from './sample.mov';
import AWS from 'aws-sdk';
import Cookies from 'universal-cookie';
import path from "path";
//import { PutObjectCommand } from "@aws-sdk/client-s3";
//import { s3Client } from "./libs/s3Client.js";
const S3_BUCKET ='hksms-upload';
const REGION ='ap-southeast-1';

AWS.config.update({
  accessKeyId: 'AKIATZIG5XR6HCKMURMR',
  secretAccessKey: 'HXMvb/6+qXVnEC466uCs/A67RMlTpYKXelN8gM97+BPrWQUY6g+BWxJhQfzS'
})

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET},
  region: REGION,
})
//dayjs.extend(customParseFormat);
function rand_string(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function App() {

  const currentYear = new Date().getFullYear();
  const videoUploadSizeLimit = 2147483648;
  const [page, setPage] = useState(
    "Loading",
    "Login",
    "NotStarted",
    "Email",
    "Declaration",
    "Upload",
    "Response",
    "Error",
    // "Ended",
    "CookieDisable"
  );
  //const [browserError, ] = useState({});
  useEffect(() => {
    if (page === 'Response') {
      _cookie.remove("slot")
      console.log("Cookie removed")
    }
    console.log(page);
    console.log('page Changed', page, new Date());
  }, [page]);
  //loign
  const [refNum, setRefNum] = useState("");
  const [validCode, setValidCode] = useState("");

  // form values
  const [email1,setEmail1] = useState();
  const [email2,setEmail2] = useState();
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const relationOptions = [
    { label: "本人 Competitor myself", value: "s1" },
    { label: "會員 Member", value: "s2" },
    { label: "導師 Tutor", value: "s3" },
    { label: "家長 Parent", value: "s4" },
  ];
  const [relationValue, relationSetValue] = useState();
  const [relatName, setRelatName] = useState();
  const shareOptions = [
    { label: "是 Yes", value: "yes" },
    { label: "否 No", value: "no" },
  ];
  const [shareValue, shareSetValue] = useState();
  const [agree, setAgree] = useState(false);




// logic / util
  const [refNumError, setRefNumError] = useState(false);

  const [emailError, setEmailError] = useState(
    "none",
    "EmailInvalid",
    "EmailInputWrong",
    "empty"
  );
  const [phoneError, setPhoneError] = useState(
    "none",
    "empty"
  );
  const [resultData, setResultData] = useState(null);

  //const [videoFormat, setVideoFormat] = useState(false);
  const [validExt, setValidExt] = useState(false);
  const [validResolution, setValidResolution] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const nowDate = new Date();
  const protectDate = new Date()
  const startDate = new Date();
  const _endDate = new Date();
  const _cookie = new Cookies();
  const _testing = new Cookies();
  const endDate = new Date();
  const [submitStarted, setSubmitStarted] = useState(false);
  const [submitDateExpired, setSubmitDateExpired] = useState(false);
  const [textDisplayOrigin, setTextDisplay] = useState({
    upload_success:`感謝你提交表格，你將會於30分鐘內收到系統電郵（若當時上載量較多，或需等候更長時間）。如未有收到系統電郵，請檢查你電郵信箱中的垃圾及不同信件匣，或登入 <a href="https://hksmsa.elearningpro.com/search/">網上表格提交紀錄</a> 以查閱提交情況。
    如果沒有顯示提交紀錄，表示你是次的影片提交未能成功，請重新填寫及提交表格。
    請核對系統電郵或提交紀錄內容，包括提交資料是否正確，及影片是否正確、完整及流暢。如發現任何問題，請於限期前 (2022年11月24日下午5時正) <a href="https://hksmsa.elearningpro.com">按此連結</a> 重新提交，否則本會有權不評審影片。
    請注意，完成提交影片不代表本會確認此提交紀錄符合參賽要求，提交人/參賽者務必確保所提交的資料正確。
    上傳參考編號: {referCode}
    
    Thank you for your submission. You will receive an email acknowledging submission within 30 minutes (or longer waiting time if uploads traffic is heavy). If you have not received it in your inbox, please check your SPAM and other mail boxes; or log in to <a href="https://hksmsa.elearningpro.com/search/">Video Submission Form Record</a> to check your submission status.
    If there is no submission record, it means the submission is unsuccessful. Please fill in and submit the form again.
    Please verify the content in the acknowledging email or "Record", including whether the information is correct or not, and the video is correct / complete and smooth or not. If any problem is found, please <a href="https://hksmsa.elearningpro.com">click here</a> to re-submit before the submission deadline (5:00 p.m. on 24 November 2022). The Association reserves the right of not adjudicating the video otherwise.
    Please note that successful submission of this form does not mean the Association confirms the submission meeting the entry requirements. You must make sure all the information submitted is correct.
    Upload Reference ID: {referCode}`,
    video_notice:`提交人先將比賽影片上載於YouTube，然後透過此表格提交YouTube影片連結。務必確保連結設定為「不公開」 (擁有連結的人可以查看)，直至2023年2月10日。
    <a href="https://drive.google.com/file/d/1ZhFLJ977Hc66Pcu-evl9wl4qDZoLhT5P/view?usp=share_link" target="_blank">有關上載YouTube教學請按此</a>。
    
    Submitters should first submit their competition videos to YouTube, then submit the YouTube link via this Form.  Please ensure the link is set as "unlisted"  (Anyone with the link can view) until 10 February 2023.
    <a href="https://drive.google.com/file/d/1kgwFPz7AyoonInWOUfdRUwRyh7ccWyM8/view?usp=share_link" target="_blank">Please press here for the Procedure to upload to YouTube</a>.`
  });
  const [textDisplay,] = useState({});

  const [txtStartDateChi, setStartDateChi] = useState();
  const [txtEndDateChi, setEndDateChi] = useState();
  const [txtStartDateEng, setStartDateEng] = useState();
  const [txtEndDateEng, setEndDateEng] = useState();
  const [txtDeadlineChi, setTxtDeadlineChi] = useState();
  const [txtDeadlineEng, setTxtDeadlineEng] = useState();
  const [textDisplayCode, ] = useState([]);
  //const [textDisplayVar, ] = useState([]);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const [referCode, setReferCode] = useState(null);
  const [originVideoName, setOriginVideoName] = useState(null);
  const [customVideoUrl, setCustomVideoUrl] = useState(null);

  // functions
  const processResult = (json) => {
    if (json.msg) {
      alert(json.msg);
    }
    /*if (json.p_login === false) {
      setPage("Login");
      return false;
    }*/
    if (json.login === false) {
      setPage("Login");
      setRefNumError(true);
      return false;
    }
    return true;
  }
  const nextPage = (pageData) => {
    console.log("In Change Page :", pageData);

    switch (pageData) {
      case "NotStarted":
        return "NotStarted";
      case "Queue":
        return "Login";
      case "Login":
        return "Email";
      case "Email":
        return "Declaration";
      case "Declaration":
        return "Upload";
      case "Upload":
        return "Response";
      default:
        return "Login";
    }
  };



  
  const getConfig = ()=>{
    fetch("/api/participant/getConfig.php", {
      method: "post",
    })
    .then((response) => response.json())
      .then((result) => {
      
      if (result != null && processResult(result)){
        if (result['data']) {
          if (result['data']['start_date']){
            let mStartDate = dayjs(result['data']['start_date'], 'YYYY-MM-DD HH:mm:ss');
            startDate.setFullYear(mStartDate.year(), mStartDate.month(), mStartDate.date());
            startDate.setHours(mStartDate.hour(), mStartDate.minute(), mStartDate.second(), 0);
            setStartDateChi(mStartDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
            setStartDateEng(mStartDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
            console.log('startDate', startDate, new Date());
            
            let mEndDate = dayjs(result['data']['end_date'], 'YYYY-MM-DD HH:mm:ss');
            _endDate.setFullYear(mEndDate.year(), mEndDate.month(), mEndDate.date());
            _endDate.setHours(mEndDate.hour(), mEndDate.minute(), mEndDate.second(), 0);
            setEndDateChi(mEndDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
            setEndDateEng(mEndDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
            console.log('_endDate', _endDate, new Date());
            
            let mProtectDate = dayjs(result['data']['protect_date'], 'YYYY-MM-DD HH:mm:ss');
            protectDate.setFullYear(mProtectDate.year(), mProtectDate.month(), mProtectDate.date());
            protectDate.setHours(mProtectDate.hour(), mProtectDate.minute(), mProtectDate.second(), 0);
            // setEndDateChi(mProtectDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
            // setEndDateEng(mProtectDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
            console.log('protectDate', protectDate);

            if (new Date() < protectDate) {
              console.log('Before', protectDate)
              if (startDate < new Date()){
                setSubmitStarted(true);
                if (result['data']['enable_user_queue'] == 'Y'){
                  window.startQueue();
                }
                  setPage("Login");
                /*if (browserError.mp4 || browserError.mov){
                  setPage("videoWarning");
                }else{
                  if (result['data']['enable_user_queue'] == 'Y'){
                    window.startQueue();
                    setPage("Login");
                  }
                }*/
              }else{
                setPage("NotStarted");
                //setPage("Login");
              }                   
            } else {
              console.log('After', protectDate)
              if (!navigator.cookieEnabled) {
                // _cookie.set("testing", 'testing_var', { path: '/', expires: new Date(Date.now() + 240 * 60 * 1000) });
                // alert("Try set testing cookie")
                alert("請注意：瀏覽器無法使用Cookie，請允許瀏覽器使用Cookie。\nAttention: The browser was not able to use Cookie, please enable Cookie if possible.")
                setPage("CookieDisable")
              } else {
                if (startDate < new Date() && _endDate > new Date()) {
                  console.log('State: Started')

                  var cookie = _cookie.get("slot", { path: '/' })

                  if (cookie !== undefined && cookie !== null) {
                    console.log("update cookie")
                    cookie === "true" ? cookie = "false" : cookie = "true"
                    _cookie.set("slot", cookie, { path: '/', expires: new Date(Date.now() + 240 * 60 * 1000) })  
                  } else {
                    console.log("set cookie")
                    _cookie.set("slot", "true", { path: '/', expires: new Date(Date.now() + 240 * 60 * 1000) })
                  }
                  // _cookie.set("slot", true, { path: '/', expires: new Date(Date.now() + 240 * 60 * 1000) });
                  console.log('check cookie: ', _cookie.get("slot", {path: '/'}));
                  //   console.log('check cookie: ', _cookie.get("slot", {path: '/'}));
                  // if (_cookie.get("slot") !== undefined && _cookie.get("slot") !== '') {
                  //   console.log('remove cookie')
                  //   _cookie.remove('slot')
                  // } else {
                  //   console.log("set cookie")
                  //   _cookie.set("slot", true, { path: '/', expires: new Date(Date.now() + 240 * 60 * 1000)});
                  //   console.log('check cookie: ', _cookie.get("slot", {path: '/'}));
                  // }
                  
                  if (result['data']['enable_user_queue'] == 'Y'){
                    window.startQueue();
                  }
                  setSubmitStarted(true);
                  setPage("Login");
                  /*if (browserError.mp4 || browserError.mov){
                    setPage("videoWarning");
                  }else{
                    if (result['data']['enable_user_queue'] == 'Y'){
                      window.startQueue();
                      setPage("Login");
                    }
                  }*/
                } else {
                  if (startDate > new Date()) { 
                    console.log('State: not start')
                    setPage("NotStarted");
                  } else if (_endDate < new Date()) {
                    console.log('State: ended')
    
                    if (_cookie.get("slot", {path: '/'}) !== undefined && _cookie.get("slot", {path: '/'}) !== '') {
                      console.log('have cookie')
                      // _cookie.remove("slot");
                      
                      window.startQueue();
                      setPage("Login");
                    } else {
                      setSubmitDateExpired(true);
                      setPage("Login")
                    }
                  }
                  //setPage("Login");
                }
              }   
            }
          }
            

          // if (result['data']['start_date']){
          //   let mStartDate = dayjs(result['data']['start_date'], 'YYYY-MM-DD HH:mm:ss');
          //   startDate.setFullYear(mStartDate.year(), mStartDate.month(), mStartDate.date());
          //   startDate.setHours(mStartDate.hour(), mStartDate.minute(), mStartDate.second(), 0);
          //   setStartDateChi(mStartDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
          //   setStartDateEng(mStartDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
          //   console.log('startDate',startDate,new Date());
          //   if (startDate < new Date()){
          //     setSubmitStarted(true);
          //     if (result['data']['enable_user_queue'] == 'Y'){
          //       window.startQueue();
          //     }
          //       setPage("Login");
          //     /*if (browserError.mp4 || browserError.mov){
          //       setPage("videoWarning");
          //     }else{
          //       if (result['data']['enable_user_queue'] == 'Y'){
          //         window.startQueue();
          //         setPage("Login");
          //       }
          //     }*/
          //   }else{
          //     setPage("NotStarted");
          //     //setPage("Login");

          //   }
          // }
        }
      }
    }).catch((err)=>{
      console.log(err)
      // setStartDateChi("test");
      // setStartDateEng("test");
      // setResultData({});
      // setPage("Declaration");
      setResultData({
        "id": 99372,
        "competition": "tester",
        "name": "Dummy 6",
        "class": "T999(6)",
        "reference_number": "33223316",
        "validation_code": "JJEEJJ",
        "email": "tatkilui@gmail.com.test.test",
        "phone": "12345678",
        "originVideoName": "4Kwmv.wmv",
        "video_id": "670085080",
        "video_url": "https://vimeo.com/670085080/7cbcc800cf",
        "video_size": "13540831",
        "upload_time": {
            "date": "2022-01-26 12:48:18.000000",
            "timezone_type": 3,
            "timezone": "UTC"
        },
        "questDeclare": "YES",
        "questRelation": "Competitor myself",
        "questName": "Test 4kwmv",
        "questShare": "No",
        "transcode": null,
        "referID": "TMZFYT0C4FCFXAA42",
        "amount": "single",
        "submit_end_date": "2023-03-01 00:00:00",
        "status": "active"
    });
    setTxtDeadlineChi('aaa');
    setTxtDeadlineEng('bbb');
      //setPage("NotStarted");
      setRelatName("test");
      setReferCode("adasdasdad");
      setPage("Upload");
    });

  };
  const getTexts = ()=>{
    fetch("/api/participant/getTexts.php", {
      method: "post",
    })
    .then((response) => response.json())
    .then((result) => {
      
      if (result != null && processResult(result)){
        if (result['data']){
          setTextDisplay(result['data']);
          for (let code in textDisplayOrigin){
            let variables = [...textDisplayOrigin[code].matchAll(/{([^}]+)}/g)];
            for (let i = 0; i > variables.length; i++){
              textDisplayCode[variables[i][0]] = variables[i][1];
              if (textDisplayCode.indexOf(variables[i][1]) == -1){
                textDisplayCode.push(variables[i][1]);
                //eval("textDisplayVar.push("+variables[i][1]+")");
              }
            }
          }

        }
      }
    }).catch((err)=>{
      
      //setPage("NotStarted");
    }).finally(()=>{
    });

  };
  const processLink = (htmlInput)=>{
    
    //htmlInput = htmlInput.replace(/{([^}]+)}/g, "$1");
    let htmlToReactParser = new HtmlToReactParser();
    let reactElement = htmlToReactParser.parse(htmlInput);
    //let reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);
    return reactElement;
  }
  const displayText = (code)=>{
    return processDisplayText(textDisplayOrigin[code])
    return textDisplay[code];
  }
  const processDisplayText = (text)=>{
    if (text){
      let output = text;
      let matcher = output.matchAll(/{([^}]+)}/g);
      //console.log('matcher',matcher);
      let done = false;
      while (!done){
        let match = matcher.next();
        done = match.done;
        if (!done){
          let value_name = match.value[1];
          output = output.replace(new RegExp(match.value[0],"g"), eval(value_name));
        }
      }
      //console.log('output',output);
      return <Grid gap="small" overflow="auto">{
        typeof output == "string" && output.split(/\r\n|\n|\r/gm).map(
          line => {
          
          return <Text size="auto">{processLink(line)}</Text>
          }
        )
      }</Grid>;
    }else{
      return code;
    }
  }
  //console.log('processDisplayText', textDisplay);
  for (var code in textDisplayOrigin){
    textDisplay[code] =  processDisplayText(textDisplayOrigin[code]);
  }
  //console.log('endprocessDisplayText', textDisplay);
  useEffect(()=>{
    if (page === "Loading"){
      getConfig();
      getTexts();
    }
    /*console.log('testmp4',testmp4);
    const videoMp4 = document.createElement("video");
    videoMp4.src = testmp4;
    console.log(videoMp4);

    videoMp4.addEventListener("loadedmetadata",
      function () {
        console.log('videoMp4',videoMp4);
        console.log('videoMp4',videoMp4.videoWidth);
        if (videoMp4.videoWidth == 0 || videoMp4.videoHeight == 0){
          browserError.mp4 = true;
          console.log('setMP4Error');
        }
        console.log('testmov',testmov);
        const videoMov = document.createElement("video");
        videoMov.src = testmov;
        console.log(videoMov);
    
        videoMov.addEventListener("loadedmetadata",
          function () {
            console.log('videoMov',videoMov);
            console.log('videoMov',videoMov.videoWidth);
            if (videoMov.videoWidth == 0 || videoMov.videoHeight == 0){
              browserError.mov = true;
              console.log('setMOVError');
            }
            if (browserError.mov || browserError.mp4){
              setPage("videoWarning");
            }else{
              getConfig();
              getTexts();
            }
          }
        );
      }
    );*/
  }, [page]);
  
  const validAC = () => {
    setSubmitDateExpired(false);

    //setRefNum(document.getElementById("refNum").value);
    //setValidCode(document.getElementById("validCode").value);
    var formData = new FormData();
    formData.append("referNum", refNum);
    formData.append("validCode", validCode);

    fetch("/api/participant/login.php", {
      method: "post",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        if (result == null ) {
          setRefNumError(true);
        } else if (processResult(result)){
          
          setRefNumError(false);
          //console.log("result: ", result);
          setResultData(result['data']);
          //console.log("resultData: ", resultData);

          if (result['submit_expired']) {
            setSubmitDateExpired(true);
          } else {
            //console.log("end: " + endDate.toUTCString());
            //console.log("now: " + nowDate.toUTCString());
            //let mStartDate = dayjs(result['submit_start_date'].date, 'YYYY-MM-DD HH:mm:ss');
            let mEndDate = dayjs(result['data']['submit_end_date'], 'YYYY-MM-DD HH:mm:ss');
            mEndDate.utcOffset(8, true);
            //mStartDate.utcOffset(8, true);
            //startDate.setFullYear(mStartDate.year(), mStartDate.month(), mStartDate.date());
            //startDate.setHours(mStartDate.hour(), mStartDate.minute(), mStartDate.second(), 0);
            endDate.setFullYear(mEndDate.year(), mEndDate.month(), mEndDate.date());
            endDate.setHours(mEndDate.hour(), mEndDate.minute(), mEndDate.second(), 0);
            //setTxtDeadlineChi("2043年4月28日下午5時");
            //mEndDate.format("YYYY年M月D日Ah時").replace("AM","上午").replace("PM","下午");
            setTxtDeadlineChi(mEndDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
            //setTxtDeadlineEng("5:00 p.m. on 28 April 2043");
            setTxtDeadlineEng(mEndDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
            /*console.log("endDate: " + endDate.toUTCString());
            console.log("endDate: " + mEndDate.toString());
            console.log("endDate: " + mEndDate.format("YYYY年M月D日Ah時mm分").replace("AM","上午").replace("PM","下午").replace("00分",""));
            console.log("endDate: " + mEndDate.format("h:mm A on D MMMM YYYY").replace("AM","a.m.").replace("PM","p.m."));
            console.log("endDate: " + txtDeadlineChi);
            console.log("endDate: " + txtDeadlineEng);*/

            setPage(nextPage(page));
            //console.log("Success: ", result);
          }


        }

      })
      .catch((error) => {
        console.error("Valid Error: ", error);
          setRefNumError(true);
      });
  };

  const checkEmail = () => {
    //var email1 = document.getElementById("emailAddr1").value;
    //var email2 = document.getElementById("emailAddr2").value;
    var error = false;
    /*if (phone == null || phone == ''){
      setPhoneError('empty');
      error = true;
    }else{
      setPhoneError(null);
    }*/
    if (email1 == null || email1 == ''){
      setEmailError('empty');
      error = true;
    }else{
      setEmailError(null);
    }
    if (email1.includes("@") && email1.split('@')[1].includes(".")) {
      if (email1 === email2) {
        setEmailError(null);
        setEmail(email1);

        //console.log(email);
      } else {
        setEmailError("EmailInputWrong");
        error = true;
      }
    } else {
      setEmailError("EmailInvalid");
      error = true;
    }
    if (!error){
      setPage(nextPage(page));
    }
  };

  const checkAgree = () => {
    if (
      document.getElementById("declare").value != null &&
      relationValue != null &&
      document.getElementById("relatName").value != null &&
      shareValue != null &&
      document.getElementById("know").value != null
    ) {
      setAgree(false);
      setRelatName(document.getElementById("relatName").value);

      setPage(nextPage(page));
    } else {
      setAgree(true);
    }
  };
  const [uploadXhr,setUploadXhr] = useState({})
  //const [lastProgressTime,setLastProgressTime] = useState();
  const [showCancelButton,setShowCancelButton] = useState(false);
  const cancelUpload = ()=>{
    setUploading(false);
    setUploadError(false);
    setPage("Upload");
    //console.log('cancelUpload',uploadXhr);
    if (typeof uploadXhr.abort == 'function'){
      //console.log('cancelUpload.abort');
      uploadXhr.abort();
      //console.log('cancelUpload.abort2');
    }
  }
  const retryUpload = ()=>{
    cancelUpload();
    setUploadPercentage(0);
    //uploadToVimeo();
    uploadS3();
  }
  const updateParticipant = ()=>{
    
    var formData = new FormData();
    formData.append("referNum", refNum);
    formData.append("validCode", validCode);

    fetch("/api/participant/login.php", {
      method: "post",
      body: formData,
    })
    .then((response) => response.json())
    .then((result)=>{
      if (result != null && result.success){
        var formData = new FormData();
        formData.append("oldVideoID", resultData["video_id"]);
        formData.append(
          "videoName",
          ""
        );
        formData.append("refNum", resultData["reference_number"]);
        formData.append("validCode", resultData["validation_code"]);
        formData.append("relation", relationValue);
        formData.append("fillName", relatName);
        formData.append("share", shareValue);
        formData.append("email", email);
        formData.append("phone", phone);
        formData.append("videoID", "");
        formData.append("videoLink", customVideoUrl);
        formData.append(
          "videoSize",
          ""
        );

        setUploading(true);
        var xhr = new XMLHttpRequest();

        xhr.open("post", "/api/participant/update.php", true);
        xhr.timeout = 45000;
        xhr.responseType = "json";
        xhr.onload = function () {
          if (xhr.status == 200) {
            // console.log(xhr.response);
            setReferCode(xhr.response.referCode);
            setOriginVideoName(xhr.response.originVideoName);
            setUploading(false);
            setPage(nextPage(page));

            //console.log("referID: " + xhr.response.referCode);
            //console.log("origin video name: " + xhr.response.originVideoName);
          }
        };

        xhr.send(formData);
        // setUploadResult(xhr.result);
        console.log("Upload Successful", customVideoUrl);

      }
    })
  }
  /*const uploadToVimeo_test = () => {
    clientid = '765a6dc58a2d7cf88c56b1a6d10eb6e09d02b7c8';
    clientsecret = 'eqjAjC6bYpPc3Zt/LAhq/LH+3QTIWuLw741H7E5hFJstHNce9L6XK77T2fqPjTMdX7Z4E9Vc2hhWCbCnIr/YtxCp6SlaONcFCFlmRF31s1W17YPrfQ3AwcPT68dQGe3k'
    accesstoken = 'a929cabfe8465956ae7dd645a922605f';
    folder = '22453349';
    client = new Vimeo(clientid, "{client_secret}", accesstoken);
  }*/
  const uploadToVimeo = () => {
    
    setUploading(true);
    try {
          window.lastProgressTime = new Date();
            var progressChecker = setInterval(() => {
              //console.log(new Date(), window.lastProgressTime, new Date() - window.lastProgressTime);
              if (new Date() - window.lastProgressTime > 30000){
                setShowCancelButton(true);
                clearInterval(progressChecker);
              }
            }, 1000);
            var vUpload = new VimeoUpload({
              name: resultData["name"] + " " + resultData["class"],
              file: document.getElementById("videoFile").files[0],
              token: "a929cabfe8465956ae7dd645a922605f",
              upgrade_to_1080: false,
              folder_uri:"/folders/27706538",
              //params:{folder_uri:"/folders/12935416"},
              onError: function (data) {
                console.log('vimeo error');
                //setUploadError(true);
                //setUploading(false);
                //console.log("test", data);
                //console.log("Error:", JSON.parse(data).error);
                //setPage("Error");
                clearInterval(progressChecker);
                uploadS3();
              },
              onProgress: function (data) {
                //console.log('onProgress',data);
                setUploadPercentage(Math.round((data.loaded / data.total) * 100), 2);
                window.lastProgressTime = new Date();
              },
              onComplete: function (videoId, index) {
                clearInterval(progressChecker);
                //console.log("videoId", videoId);
                // var url = "https://player.vimeo.com/video/" + videoId;
      
                var url = "";
                //console.log(this.metadata);
                if (index > -1) {
                  /* The metadata contains all of the uploaded video(s) details see: https://developer.vimeo.com/api/endpoints/videos#/{video_id} */
                  url = this.metadata[index].link; //
      
                  //console.log(this.metadata[index]); /* echo server data */
                }
                // add folder
                //var client = new Vimeo(CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN);
                // keep login
                var formData = new FormData();
                formData.append("referNum", refNum);
                formData.append("validCode", validCode);
            
                fetch("/api/participant/login.php", {
                  method: "post",
                  body: formData,
                })
                .then((response) => response.json())
                .then((result)=>{
                  if (result != null && result.success){
                    var formData = new FormData();
                    formData.append("oldVideoID", resultData["video_id"]);
                    formData.append(
                      "videoName",
                      document.getElementById("videoFile").files[0].name
                    );
                    formData.append("refNum", resultData["reference_number"]);
                    formData.append("validCode", resultData["validation_code"]);
                    formData.append("relation", relationValue);
                    formData.append("fillName", relatName);
                    formData.append("share", shareValue);
                    formData.append("email", email);
                    formData.append("phone", phone);
                    formData.append("videoID", videoId);
                    formData.append("videoLink", url);
                    formData.append(
                      "videoSize",
                      document.getElementById("videoFile").files[0].size
                    );
          
                    setUploading(true);
                    var xhr = new XMLHttpRequest();
          
                    xhr.open("post", "/api/participant/update.php", true);
                    xhr.timeout = 45000;
                    xhr.responseType = "json";
          
                    xhr.send(formData);
          
                    // setUploadResult(xhr.result);
          
                    console.log("Upload Successful", url);
          
                    xhr.onload = function () {
                      if (xhr.status == 200) {
                        // console.log(xhr.response);
                        setReferCode(xhr.response.referCode);
                        setOriginVideoName(xhr.response.originVideoName);
                        setUploading(false);
                        setPage(nextPage(page));
          
                        //console.log("referID: " + xhr.response.referCode);
                        //console.log("origin video name: " + xhr.response.originVideoName);
                      }
                    };
                  }else{
                      
                  setPage("Error");
                  }
                })
              },
            });
            vUpload.upload();
            setUploadXhr(vUpload.xhr);
    } catch (e) {
      console.log("Error: ", e);
      setUploading(false);
      setPage("Error");
    }
  };
  const uploadS3 = ()=>{
    console.log("s3 start");
    setUploading(true);
    try {
          window.lastProgressTime = new Date();
          let reader = new FileReader();
          let file = document.getElementById("videoFile").files[0];
          let rand_filename = rand_string(20);
          let s3_path = "78_music/"+refNum + "/" + rand_filename + '.' + file.name.split(".").pop()
          reader.addEventListener('loadend', function(e){

            const params = {
                ACL: 'public-read',
                Body: file,
                Bucket: S3_BUCKET,
                Key: s3_path
            };
    
            var progressChecker = setInterval(() => {
              //console.log(new Date(), window.lastProgressTime, new Date() - window.lastProgressTime);
              if (new Date() - window.lastProgressTime > 30000){
                setShowCancelButton(true);
                clearInterval(progressChecker);
              }
            }, 1000);
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                  setUploadPercentage(Math.round((evt.loaded / evt.total) * 100))
                })
                .on('complete',()=>{
                })
                .on('error', function(response) {
                  setUploadError(true);
                  //console.log("test", data);
                  //console.log("Error:", JSON.parse(data).error);
                  clearInterval(progressChecker);
                  setUploading(false);
                  setPage("Error");
                })
                .on('success', function(response) {
                  console.log(response.data);
                  var result = response.data;
                  if (result != null && result.ETag){
                    var formData = new FormData();
                    formData.append("oldVideoID", resultData["video_id"]);
                    formData.append("videoName", file.name);
                    formData.append("refNum", resultData["reference_number"]);
                    formData.append("validCode", resultData["validation_code"]);
                    formData.append("relation", relationValue);
                    formData.append("fillName", relatName);
                    formData.append("share", shareValue);
                    formData.append("email", email);
                    formData.append("phone", phone);
                    formData.append("videoID", "");
                    formData.append("s3_upload", "yes");
                    formData.append("s3_path", s3_path);
                    
                    //formData.append("videoLink", customVideoUrl);
                    formData.append(
                      "videoSize",
                      document.getElementById("videoFile").files[0].size
                    );
            
                    setUploading(true);
                    var xhr = new XMLHttpRequest();
            
                    xhr.open("post", "/api/participant/update.php", true);
                    xhr.timeout = 45000;
                    xhr.responseType = "json";
                    xhr.onload = function () {
                      if (xhr.status == 200) {
                        // console.log(xhr.response);
                        setReferCode(xhr.response.referCode);
                        setOriginVideoName(xhr.response.originVideoName);
                        clearInterval(progressChecker);
                        setUploading(false);
                        setPage(nextPage(page));
            
                        //console.log("referID: " + xhr.response.referCode);
                        //console.log("origin video name: " + xhr.response.originVideoName);
                      }
                    };
                    console.log("s3 start upload");
                    xhr.send(formData);
            
                    // setUploadResult(xhr.result);
            
                    console.log("Upload Successful", customVideoUrl);
            
                  }
                })
                .send((err) => {
                    if (err) console.log(err)
                })

          });
          reader.readAsArrayBuffer(file);
    } catch (e) {
      console.log("Error: ", e);
      setUploading(false);
      setPage("Error");
    }

  }

  const handleNothing = (e) => {
    e.preventDefault();
  };
  const myTheme = {
    global: {
      animation: {
        duration: '10s',
      },
    },
  };
  return (
    <Grommet theme={myTheme} flex="grow" full fill >
      {(page === "Loading" || page === "NotStarted" || page === "Login" || page === "Email" || page === "videoWarning" || page === "Ended" || page === "CookieDisable") && (
        <Box background="light-4"  fill>
          <Box
            pad="large"
            gap="medium"
            justify="center"
            align="center"
            overflow="auto"
            height="100%"
          >
            <Card
              width="large"
              align="left"
              background="white"
              elevation="xlarge"
              __flex="false"
            >
              <CardHeader
                pad="medium"
                width="100%"
                background="white"
                justify="start"
              >
                <Image src={logo} width={"40px"}></Image>
                <Box>
                  <Text weight={"bold"} size="100%">
                  第78屆香港學校音樂節 – 提交影片網上表格
                  </Text>
                  <Text weight={"bold"} size="80%">
                  78th Hong Kong Schools Music Festival - Video Submission
                    Form
                  </Text>
                </Box>
              </CardHeader>
              <CardBody
                __pad="5%"
                __gap="xsmall"
                background="white"
                justify="center"
                align="center"
                flex
                overflow={"auto"}
              >
                <Box
                pad="5%"
                gap="xsmall"
                >

              {
                page === "Loading" &&
                (
                  <Layer position="center" opacity="strong" background="none" responsive={false} style={{maxWidth:"100%", width:"200px",borderRadius:"50%"}} >
                  <Spinner  size="xlarge" width="200px" height="200px" background={"light-3"}/>
                  
                  </Layer>
                )
              }
                {page === "NotStarted" && (
                  <Box justify="center" align="center" gap="small" pad="small">
                    <Box justify="center" align="left">
                      <Text size="65%" color="red">
                        {displayText('not_started')}
                      </Text>
                    </Box>
                  </Box>
                  )
                }
                {page === "Ended" && (
                  <Box justify="center" align="center" gap="small" pad="small">
                    <Box justify="center" align="left">
                      <Text size="65%" color="red">
                        {displayText('ended')}
                      </Text>
                    </Box>
                  </Box>
                  )
                }
                {page === "CookieDisable" && (
                  <Box justify="center" align="center" gap="small" pad="small">
                    <Box justify="center" align="left">
                        <Text size="65%" color="red">
                          請注意：瀏覽器無法使用Cookie，請允許瀏覽器使用Cookie。<br></br>
                          Attention: The browser was not able to use Cookie, please enable Cookie if possible.
                        </Text>
                        <br></br>
                        <Text size="80%">
                          <a href="https://support.google.com/accounts/answer/61416?hl=zh-Hant&co=GENIE.Platform%3DAndroid" target={{target: '_black'}}>如何從 Chrome 瀏覽器啟用 Cookie</a><br></br>
                          <a href="https://support.apple.com/zh-hk/guide/safari/ibrw850f6c51/16.1/mac/13.0" target={{target: '_black'}}>如何在從Safari 瀏覽器啟用 Cookie (Mac)</a><br></br>
                          <a href="https://support.apple.com/zh-hk/HT201265" target={{target: '_black'}}>如何在從Safari 瀏覽器啟用 Cookie (iPhone & iPad)</a><br></br>
                          <a href="https://support.mozilla.org/zh-TW/kb/websites-say-cookies-are-blocked-unblock-them" target={{target: '_black'}}>如何從 Firefox 瀏覽器啟用 Cookie</a><br></br>
                          <a href="https://cookie-script.com/knowledge-base/enable-cookies-edge" target={{target: '_black'}}>如何從 Edge 瀏覽器啟用 Cookie</a><br></br>
                          <a href="https://www.smilepay.net/faq/cookie.html" target={{ target: '_black' }}>如何從 IE6-11 瀏覽器啟用 Cookie</a><br></br>
                          <br></br>
                          <a href="https://support.google.com/accounts/answer/61416?hl=en&co=GENIE.Platform%3DAndroid" target={{ target: '_black' }}>How to enable cookie from Chrome browser</a><br></br>
                          <a href="https://support.apple.com/guide/safari/enable-cookies-ibrw850f6c51/mac" target={{ target: '_black' }}>How to enable cookie from Safari browser (Mac)</a><br></br>
                          <a href="https://support.apple.com/en-us/HT201265" target={{ target: '_black' }}>How to enable cookie from Safari browser (iPhone & iPad)</a><br></br>
                          <a href="https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them" target={{ target: '_black' }}>How to enable cookie from Firefox browser</a><br></br>
                          <a href="https://cookie-script.com/knowledge-base/enable-cookies-edge" target={{ target: '_black' }}>How to enable cookie from Edge browser</a><br></br>
                          <a href="https://www.whatismybrowser.com/guides/how-to-enable-cookies/internet-explorer" target={{ target: '_black' }}>How to enable cookie from IE6-11 browser</a><br></br>
                        </Text>
                    </Box>
                  </Box>
                  )
                }
                {/*page === "videoWarning" && (
                  <Box justify="center" align="center" gap="small" pad="small">
                    {browserError.mp4 && 
                      <Box justify="center" align="left">
                        <Text size="65%" color="red">
                          {displayText('mp4Error')}
                        </Text>
                      </Box>
                    }
                    {browserError.mov &&
                      <Box justify="center" align="left">
                        <Text size="65%" color="red">
                          {displayText('movError')}
                        </Text>
                      </Box>
                    }
                    <Box justify="center" align="left">
                      <Text size="65%" color="red">
                        建議使用 Chrome、Safari 或 Edge 瀏覽器。
                      </Text>
                      <Text size="65%" color="red">
                        Chrome, Safari & Edge Browsers are recommended.
                      </Text>
                    </Box>
                  </Box>
                  )*/
                }
                
                {page === "Login" && (
                  <Box align="center" gap="small" pad="small" fill>
                      {!submitDateExpired &&
                        <>
                        <br></br>
                      <Grid
                      justify="center"
                      align="center"
                      >
                    <Box justify="center" align="left" flex="shrink" height="auto">
                      <Text size="65%" color="red" >
                        {displayText('login_page_message')}
                      </Text>
                    </Box>
                    </Grid>
                    <Grid
                      justify="center"
                      align="center"
                      columns={["xxsmall", "flex"]}
                    >
                      <User />
                      <TextInput
                        id="refNum"
                        name="refNum"
                        placeholder={
                          <Box>
                            <Text size="small" color="grey">
                              參考編號
                            </Text>
                            <Text size="small" color="grey">
                              Reference Number
                            </Text>
                          </Box>
                        }
                        onChange={(e)=>setRefNum(e.target.value)}
                      />
                        </Grid>
                        <br></br>
                    <Grid
                      justify="center"
                      align="center"
                      columns={["xxsmall", "flex"]}
                    >
                      <Validate />
                      <TextInput
                        id="validCode"
                        name="validCode"
                        placeholder={
                          <Box>
                            <Text size="small" color="grey">
                              驗證碼
                            </Text>
                            <Text size="small" color="grey">
                              Validation Code
                            </Text>
                          </Box>
                        }
                        onChange={(e)=>setValidCode(e.target.value)}
                      />
                        </Grid>
                        <br></br>
                      <Button
                        primary
                        label="下一步 Next Step"
                        size="small"
                        reverse
                        icon={<Login color="#49ff46" size="small" />}
                        onClick={validAC}
                      />                        
                        </>
                    }
                    <Grid 
                      justify="center"
                      align="center"
                      >
                      
                    {submitDateExpired && (
                      <Box justify="center" align="left">
                      <Text size="75%" color="red">
                        {displayText("submit_expired")}
                        </Text>
                      </Box>
                    )}
                    {refNumError && (
                      <Box>
                        <Text size="65%" color="red">
                          你輸入的參考編號及/或驗證碼與本會紀錄不符。請再次參閱「參賽通知」，然後重新填寫。
                          <br/>
                          The Reference Number and/or Validation Code does not
                          match the records of the Association.
                          <br/>
                          Please refer to the Competition Notification again and
                          re-fill the Submission Form.
                        </Text>
                      </Box>
                    )}
                    <br></br>
                    </Grid>

                  </Box>
                )}
                {page === "Email" && (
                  <Box gap="xsmall">
                    <Grid
                      gap="xsmall"
                      columns={["small", "small"]}
                      justify="start"
                      align="left"
                      pad="small"
                    >
                      <Text size="small">
                        參賽者姓名 Name of competitor(s):
                      </Text>
                      <Text id="competName" name="competName" size="small">
                        {resultData["name"]}
                      </Text>
                    </Grid>
                    <Grid
                      gap="xsmall"
                      columns={["small", "small"]}
                      justify="start"
                      align="left"
                      pad="small"
                    >
                      <Text size="small">項目編號 Class:</Text>
                      <Text id="classNum" name="classNum" size="small">
                        {resultData["class"]}
                      </Text>
                    </Grid>
                    <Grid justify="center" align="center" gap="small">
                      <Box
                        justify="center"
                        align="center"
                        gap="xsmall"
                        pad="small"
                      >
                        <Box>
                          <Text size="65%" color="red">
                            請填寫正確的電郵地址。完成提交後你將會收到系統電郵。
                          </Text>
                          <Text size="65%" color="red">
                            Please fill in a valid email address. You will
                            receive an email acknowledging your submission.
                          </Text>
                        </Box>
                        <Box gap="xsmall">
                          {/* <Grid
                            justify="center"
                            align="center"
                            columns={["xxsmall", "flex"]}
                          >
                            <Phone />
                            <TextInput
                              id="phone"
                              name="phone"
                              type="text"
                              onCut={handleNothing}
                              onCopy={handleNothing}
                              onPaste={handleNothing}
                              onChange={({target})=>{setPhone(target.value);}}
                              placeholder={
                                <Box>
                                  <Text size="small" color="grey">
                                    電話號碼
                                  </Text>
                                  <Text size="small" color="grey">
                                    Phone Number
                                  </Text>
                                </Box>
                              }
                            />
                          </Grid> */}
                          <Grid
                            justify="center"
                            align="center"
                            columns={["xxsmall", "flex"]}
                          >
                            <Mail />
                            <TextInput
                              id="emailAddr1"
                              name="emailAddr1"
                              type="email"
                              onCut={handleNothing}
                              onCopy={handleNothing}
                              onPaste={handleNothing}
                              onChange={({target})=>{setEmail1(target.value);}}
                              placeholder={
                                <Box>
                                  <Text size="small" color="grey">
                                    電郵地址
                                  </Text>
                                  <Text size="small" color="grey">
                                    Email Address
                                  </Text>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid
                            justify="center"
                            align="center"
                            columns={["xxsmall", "flex"]}
                          >
                            <Mail />
                            <TextInput
                              id="emailAddr2"
                              name="emailAddr2"
                              type="email"
                              onCut={handleNothing}
                              onCopy={handleNothing}
                              onPaste={handleNothing}
                              onChange={({target})=>{setEmail2(target.value);}}
                              placeholder={
                                <Box>
                                  <Text size="small" color="grey">
                                    再次輸入電郵地址
                                  </Text>
                                  <Text size="small" color="grey">
                                    Re-type of Email Address
                                  </Text>
                                </Box>
                              }
                            />
                          </Grid>
                          {emailError === "EmailInputWrong" && (
                            <Box>
                              <Text size="65%" color="red">
                                所填寫的電郵地址不一樣。
                              </Text>
                              <Text size="65%" color="red">
                                The email addresses are not the same.
                              </Text>
                            </Box>
                          )}
                          {emailError === "EmailInvalid" && (
                            <Box>
                              <Text size="65%" color="red">
                                電郵地址無效。
                              </Text>
                              <Text size="65%" color="red">
                                Invalid email address.
                              </Text>
                            </Box>
                          )}
                          {emailError === "empty" && (
                            <Box>
                              <Text size="65%" color="red">
                                請填寫電郵地址。
                              </Text>
                              <Text size="65%" color="red">
                                Please enter email address.
                              </Text>
                            </Box>
                          )}
                          {/* {phoneError === "empty" && (
                            <Box>
                              <Text size="65%" color="red">
                                請填寫電話號碼。
                              </Text>
                              <Text size="65%" color="red">
                                Please enter phone number.
                              </Text>
                            </Box>
                          )} */}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid>
                      
                    <Button
                      primary
                      label="下一步 Next Step"
                      size="small"
                      reverse
                      icon={<Login color="#49ff46" size="small" />}
                      onClick={checkEmail}
                    />
                    </Grid>
                  </Box>
                )}
                <br />
                {/*page === "Login" && (
                  <Button
                    primary
                    label="下一步 Next Step"
                    size="small"
                    reverse
                    icon={<Login color="#49ff46" size="small" />}
                    onClick={validAC}
                  />
                )*/}
                </Box>
              </CardBody>
              {page === "Login" ||
                (page === "Email" && (
                  <Footer background="dark-3" justify="center">
                    <Box
                      direction="row"
                      align="center"
                      justify="center"
                      pad="small"
                    >
                      <Box>
                        <Text
                          weight="bold"
                          size="65%"
                          style={{
                            color:
                              page === "Login" || page === "Email"
                                ? "Orange"
                                : "white",
                          }}
                        >
                          1. 參賽者資料
                        </Text>
                        <Text
                          weight="bold"
                          size="55%"
                          style={{
                            color:
                              page === "Login" || page === "Email"
                                ? "Orange"
                                : "white",
                          }}
                        >
                          Competitor's info
                        </Text>
                      </Box>
                      <FormNextLink color="black" />
                      <Box>
                        <Text weight="bold" size="65%">
                          2. 聲明
                        </Text>
                        <Text weight="bold" size="55%">
                          Declaration
                        </Text>
                      </Box>
                      <FormNextLink color="black" />
                      <Box>
                        <Text weight="bold" size="65%">
                          3. 影片上載及提交
                        </Text>
                        <Text weight="bold" size="55%">
                          Video Upload & Submission
                        </Text>
                      </Box>
                    </Box>
                  </Footer>
                ))}
              <CardFooter
                pad="small"
                width="100%"
                background="dark-2"
                justify="between"
              >
                <Box>
                  <Text color="white" size="60%">
                    香港學校音樂及朗誦協會
                  </Text>
                  <Text color="white" size="50%">
                    Hong Kong Schools Music and Speech Association
                  </Text>
                </Box>
                <Text
                  textAlign="end"
                  alignSelf="center"
                  size="50%"
                  color="white"
                >
                  © {currentYear} Copyright
                </Text>
              </CardFooter>
            </Card>
          </Box>
        </Box>
      )}
      {(page === "Declaration" ||
        page === "Upload" ||
        page === "Response" ||
        page === "Error") && (
          <Box
            // rows={["10%", "82.5%", "7.5%"]}
            fill
            overflow="auto"
          >
            <Header
              pad="medium"
              width="100%"
              background="white"
              justify="start"
              flex="false"
            >
              <Image src={logo} width={"40px"}></Image>
              <Box>
                <Text weight={"bold"} size="100%">
                第78屆香港學校音樂節 – 提交影片網上表格
                </Text>
                <Text weight={"bold"} size="80%">
                78th Hong Kong Schools Music Festival - Video Submission Form
                </Text>
              </Box>
            </Header>
            <Main background="dark-1" pad="1%" justify="center" flex>
              <Box background="white" justify="center" align="left" round="none" pad="medium">
                <Grid
                  columns={{ count: 4, size: "auto" }}
                  gap="small"
                  width="80%"
                >
                  <Text size="65%">參賽者姓名 Name of competitor(s):</Text>
                  <Text id="competName" name="competName" size="small">
                    {resultData["name"]}
                  </Text>
                  <Text size="65%">項目編號 Class:</Text>
                  <Text id="classNum" name="classNum" size="small">
                    {resultData["class"]}
                  </Text>
                </Grid>
                <Box pad="1%" gap="medium" overflow="auto" full fill>
                  {page === "Declaration" && (
                    <Box>
                      <Form validate={"blur"} onSubmit={checkAgree}>
                        <Grid rows={{ count: 11, size: "auto" }} gap="small">
                          <Box>
                            <Text size="65%" color="red">
                              必須填寫所有項目
                            </Text>
                            <Text size="65%" color="red">
                              All items are mandatory
                            </Text>
                          </Box>
                          <Text size="2xl">聲明 Declaration</Text>
                          <FormField name="declare" required border>
                            <Box columns={["xxsmall", "95%"]} size="medium" pad="small">
                              <CheckBox id="declare" name="declare" full label={<Box justify="center" pad="xxsmall">
                                <Text>本人聲明影片中的表演者為參賽者本人。</Text>
                                <Text>
                                  I declare that the performer(s) in the video
                                  is/are the competitor(s) who enter the
                                  competition.
                                </Text>
                              </Box>} />
                              
                            </Box>
                          </FormField>
                          <FormField
                            name="relation"
                            required
                            border
                            label={
                              <Box justify="center">
                                <Text>
                                  1. 你是否參賽者本人 / 你與參賽者的關係?
                                </Text>
                                <Text>
                                  Are you the competitor(s) yourself? / Your
                                  relationship with the competitor(s)?
                                </Text>
                              </Box>
                            }
                          >
                            <RadioButtonGroup
                              id="relation"
                              name="relation"
                              options={relationOptions}
                              value={relationValue}
                              onChange={(event) =>
                                relationSetValue(event.target.value)
                              }
                            />
                          </FormField>
                          <FormField
                            name="relatName"
                            required
                            border
                            label={"2. 你的姓名 Your name"}
                          >
                            <Box pad="small">
                            <TextInput
                              id="relatName"
                              name="relatName"
                              type="text"
                            />
                            </Box>
                          </FormField>
                          <FormField
                          pad
                            name="share"
                            required
                            border
                            label={
                              <Box justify="center">
                                <Text>
                                  3. 你是否願意讓本會使用此參賽影片作內部用途?
                                </Text>
                                <Text>
                                  Would you allow the Association to use this
                                  video for internal purpose?
                                </Text>
                              </Box>
                            }
                          >
                            <RadioButtonGroup
                              id="share"
                              name="share"
                              options={shareOptions}
                              value={shareValue}
                              onChange={(event) =>
                                shareSetValue(event.target.value)
                              }
                            />
                          </FormField>
                          <FormField name="know" required border>
                            <Box justify="center" pad="small">
                              <Text size="65%">
                                {displayText("declaration_notice")}
                              </Text>
                            </Box>
                            <Box columns={["xxsmall", "95%"]} size="medium" pad="small">
                              <CheckBox id="know" name="know" full label={<Box justify="center" pad="xxsmall" >
                                <Text>我已閱讀及知悉以上注意事項。</Text>
                                <Text>
                                  I have read and fully understood the above
                                  declaration.
                                </Text>
                              </Box>}/>
                              
                            </Box>
                          </FormField>
                          {agree && (
                            <Box>
                              <Text size="65%" color="red">
                                必須填寫所有項目
                              </Text>
                              <Text size="65%" color="red">
                                All items are mandatory
                              </Text>
                            </Box>
                          )}
                          <Box width="small" justify="center" gap="medium">
                            <Button
                              primary
                              label="下一步 Next Step"
                              type="submit"
                            />
                          </Box>
                          <Box width="xxsmall" height="xxsmall">
                            {" "}
                          </Box>
                        </Grid>
                      </Form>
                    </Box>
                  )}
                  {page === "Upload" && (
                    <Box border="2px" pad="2%" basis="large" gap="small">
                      <Text>上載影片 Video Upload</Text>
                      <Text color="red" size="small">
                              {displayText("video_notice")}
                            </Text>
                      <Form
                        id="videoForm"
                        justify="center"
                        align="center"
                        onSubmit={uploadToVimeo}
                        encType="multipart/form-data"
                        method="post"
                        onReset={() => (
                          setValidExt(false),
                          setValidResolution(false),
                          setVideoError(false)
                        )}
                      >
                        <FormField>
                          <FileInput
                            name="videoFile"
                            id="videoFile"
                            style={{ top: 0 }}
                            accept=".mp4,.mov"
                            maxSize={videoUploadSizeLimit}
                            messages={{
                              browse: "瀏覽檔案 Browse",
                              dropPrompt:
                                "拖曳檔案到此或 \n Drag and drop the file here or",
                              files: "files",
                              remove: "remove",
                              removeAll: "remove all",
                              maxFile: "Attach a maximum of {max} files only.",
                            }}
                            multiple={false}
                            onReset={() => (
                              setValidExt(false),
                              setValidResolution(false),
                              setVideoError(false)
                            )}
                            onChange={(event, { files }) => {
                              setUploadError(false);
                              if (
                                files.length > 0 
                              ) {
                                var videoFile = files[0];
                                //console.log('videoFile',videoFile)
                                var fileTypeCheck =
                                  videoFile.name.toUpperCase().endsWith(".MP4") ||
                                  videoFile.name.toUpperCase().endsWith(".MOV");

                                //console.log(videoFile.name);
                                //console.log(videoFile.name.toUpperCase());

                                if (!fileTypeCheck) {
                                  setVideoError("format");
                                  return;
                                }
                                if (videoFile.size >= videoUploadSizeLimit) {
                                  setVideoError("size");
                                  return;
                                }
                                setVideoError(null);

                                const url = URL.createObjectURL(videoFile);
                                const video = document.createElement("video");
                                video.src = url;
                                //console.log(url);
                                //console.log(video);

                                video.addEventListener(
                                  "loadedmetadata",
                                  function () {
                                    //console.log("width:", this.videoWidth);
                                    //console.log("height:", this.videoHeight);

                                    if (video.videoWidth == 0 || video.videoHeight == 0){
                                      // setVideoError("resolution_unknown");
                                      // return;
                                    }
                                    if (
                                      video.videoWidth > 1920 ||
                                      video.videoHeight > 1920
                                      || (video.videoWidth * video.videoHeight > 1920*1080)
                                    ) {
                                      setVideoError("resolution");
                                      return;
                                    }
                                  }
                                );
                              } else {
                                setVideoError(false);
                              }

                            }}
                            renderFile={(file) => (
                              <Box direction="column" gap="small">
                                <Text weight="bold" size="medium">
                                  {file.name}
                                </Text>
                                <Text
                                  weight="bold"
                                  color="text-weak"
                                  size="small"
                                >
                                  {(file.size / 1024 / 1024).toFixed(1)} MB
                                </Text>
                              </Box>
                            )}
                          />
                        </FormField>
                        {uploading && (
                          <Layer position="center" opacity="strong" background="none" responsive={false} style={{maxWidth:"100%", width:"400px"}} >
                            <Box round="medium" pad="medium"  background="dark-1">
                              {/*<Image src={loading} />*/}
                              <Stack anchor="center">
                                <Meter
                                  type="circle"
                                  values={[{
                                    value: uploadPercentage,
                                    label: uploadPercentage+'%',
                                    onClick: () => {}
                                  }]}
                                  aria-label="meter"
                                />
                                <Text justify="center" size="xxlarge" weight="bold">{uploadPercentage}%</Text>
                              </Stack>
                              {showCancelButton ?
                              <>
                              <Text>影片上傳可能有問題，你可以再試。</Text>
                              <Text>Video uploading may go wrong. You may retry.</Text>
                              <Grid columns={["auto","auto"]} pad="small">
                                <Button
                                  secondary
                                  label="取消 Cancel"
                                  size="small"
                                  reverse
                                  onClick={cancelUpload}
                                />
                                <Button
                                  primary
                                  label="重試 Retry"
                                  size="small"
                                  reverse
                                  onClick={retryUpload}
                                />
                              
                              </Grid>
                              </>
                              :
                                <>
                                <Text>影片正在上傳，請勿關閉此頁面。</Text>
                                <Text>
                                  Video Uploading. Please don't close the page.
                                </Text>
                                </>
                              }
                            </Box>
                          </Layer>
                        )}
                        {/* {videoFormat && (
                        <Box>
                          <Text size="65%" color="red">
                            你的影片檔案不符合要求。
                          </Text>
                          <Text size="65%" color="red">
                            Your video file does not fulfil the requirement.
                          </Text>
                        </Box>
                      )} */}
                        {videoError != null &&
                          videoError != false &&
                          videoError != true && (
                            <Box>
                              <Text size="65%" color="red">
                                你的影片檔案不符合要求。
                              </Text>
                              <Text size="65%" color="red">
                                Your video file does not fulfil the requirement.
                              </Text>
                            </Box>
                          )}
                        { videoError == "size" && (
                        <Box>
                          <Text size="65%" color="red">
                            你的影片檔案大小不符合要求。
                          </Text>
                          <Text size="65%" color="red">
                            Your video file size does not fulfil the
                            requirement.
                          </Text>
                        </Box>
                      )}
                      {videoError == "format" && (
                        <Box>
                          <Text size="65%" color="red">
                            你的影片檔案格式不符合要求。
                          </Text>
                          <Text size="65%" color="red">
                            Your video file format does not fulfil the
                            requirement.
                          </Text>
                        </Box>
                      )}
                      {videoError == "resolution" && (
                        <Box>
                          <Text size="65%" color="red">
                            你的影片檔案解像度不符合要求。
                          </Text>
                          <Text size="65%" color="red">
                            Your video file resolution does not fulfil the
                            requirement.
                          </Text>
                        </Box>
                      )} 
                      {videoError == "resolution_unknown" && (
                        <Box>
                          <Text size="65%" color="red">
                            我們無法正確讀取你的影片檔案解像度，請嘗試使用其他瀏覽器。
                          </Text>
                          <Text size="65%" color="red">
                            We cannot read the resolution of your video file, please try another browser.
                          </Text>
                        </Box>
                      )} 
                        {uploadError && (
                          <Box>
                            <Text size="65%" color="red">
                              上傳發生錯誤，請重新上傳。
                            </Text>
                            <Text size="65%" color="red">
                              An upload error occurred, please upload again.
                            </Text>
                          </Box>
                        )}
                        <Box direction="row" gap="small">
                          {/* {validExt && validResolution && (
                          <Grid
                            justifyContent="center"
                            align="center"
                            columns={{ count: 2, size: "auto" }}
                            gap="medium"
                          >
                            <Button
                              label="清除 Clear"
                              primary
                              name="reset"
                              type="reset"
                            />
                            <Button
                              label="提交 Submit"
                              primary
                              name="submit"
                              type="submit"
                            />
                          </Grid>
                        )} */}
                          {videoError == null && (
                            <Grid
                              justifyContent="center"
                              align="center"
                              columns={{ count: 2, size: "auto" }}
                              gap="medium"
                            >
                              <Button
                                label="清除 Clear"
                                secondary
                                name="reset"
                                type="reset"
                              />
                              <Button
                                label="提交 Submit"
                                primary
                                name="submit"
                                type="submit"
                              />
                            </Grid>
                          )}
                        </Box>
                      </Form>
                    </Box>
                  )}
                  {page === "Upload_link" && (
                    <Box border="2px" pad="2%" basis="large" gap="small" overflow="auto" full fill>
                      <Text>Google檔案連結 Google Drive Link</Text>
                      <Text color="red" size="small">
                              {displayText("video_notice")}
                            </Text>
                        
                                    <TextInput
                                        id="videoLink"
                                        name="videoLink"
                                        placeholder={
                                        <Box>
                                            <Text size="small" color="grey">
                                            請輸入Google檔案連結
                                            </Text>
                                            <Text size="small" color="grey">
                                            Please Enter Google Drive Link
                                            </Text>
                                        </Box>
                                        }
                                        onChange={(e)=>setCustomVideoUrl(e.target.value)}
                                    />

                    <Grid
                      justifyContent="center"
                      align="center"
                      columns={{ count: 1, size: "auto" }}
                      gap="medium"
                    >
                              <Button
                                  primary
                                  label="提交 Submit"
                                  onClick={updateParticipant}
                                  disabled={customVideoUrl == null || customVideoUrl.length == 0}
                              />
                            </Grid>
                    </Box>
                  )}
                  {page === "Response" && (
                    <Box pad="1%" basis="large" gap="small">
                      {displayText("upload_success")}
                    </Box>
                  )}
                  {page === "Error" && (
                    <Box pad="1%" basis="large" gap="small">
                      {displayText("upload_fail")}
                      
                                <Button
                                  primary
                                  label="重試 Retry"
                                  size="small"
                                  reverse
                                  onClick={cancelUpload}
                                />
                               
                      {/*<Text>上傳出現錯誤，請稍後再試。</Text>
                      <Text>
                        如重複出現錯誤，請確保網絡穩定，並於上傳期間閒置上傳裝置。
                      </Text>
                      <br />
                      <br />
                      <Text>
                        There was an error uploading, please try again later.
                      </Text>
                      <Text>
                        If the error occurs repeatedly, please ensure that the
                        network is stable and the uploading device is idle during
                        uploading.
                  </Text>*/}
                    </Box>
                  )}
                </Box>
              </Box>
            </Main>
            <Footer background="dark-3" pad="small">
              <Box>
                <Text
                  weight="bold"
                  size="60%"
                  style={{
                    color:
                      page === "Login" || page === "Email" ? "Orange" : "black",
                  }}
                >
                  1. 參賽者資料
                </Text>
                <Text
                  weight="bold"
                  size="50%"
                  style={{
                    color:
                      page === "Login" || page === "Email" ? "Orange" : "black",
                  }}
                >
                  Competitor's info
                </Text>
              </Box>
              <FormNextLink color="black" />
              <Box>
                <Text
                  size="60%"
                  weight="bold"
                  style={{ color: page === "Declaration" ? "Orange" : "black" }}
                >
                  2. 聲明
                </Text>
                <Text
                  size="50%"
                  weight="bold"
                  style={{ color: page === "Declaration" ? "Orange" : "black" }}
                >
                  Declaration
                </Text>
              </Box>
              <FormNextLink color="black" />
              <Box>
                <Text
                  size="60%"
                  weight="bold"
                  style={{ color: page === "Upload" ? "Orange" : "black" }}
                >
                  3. 影片上載及提交
                </Text>
                <Text
                  size="50%"
                  weight="bold"
                  style={{ color: page === "Upload" ? "Orange" : "black" }}
                >
                  Video Upload & Submission
                </Text>
              </Box>
            </Footer>
            <Footer background="dark-1" pad="0.5%"></Footer>
            <Footer
              background="dark-3"
              pad="small"
              width="100%"
              justify="between"
            >
              <Box>
                <Text color="white" size="60%">
                  香港學校音樂及朗誦協會
                </Text>
                <Text color="white" size="50%">
                  Hong Kong Schools Music and Speech Association
                </Text>
              </Box>
              <Text textAlign="end" alignSelf="center" size="50%" color="white">
                © {currentYear} Copyright
              </Text>
            </Footer>
          </Box>
        )}
    </Grommet>
  );
}

export default App;
